import { render, staticRenderFns } from "./ImportButton.vue?vue&type=template&id=54e63c68&scoped=true"
import script from "./ImportButton.vue?vue&type=script&lang=js"
export * from "./ImportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e63c68",
  null
  
)

export default component.exports